import React from 'react';

export default React.createContext({
  http: {},
  attemp: () => {},
  disabled: false,
});
